var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.811,
    height: 16.246,
    viewBox: "0 0 14.811 16.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30524",
    "data-name": "Group 30524",
    transform: "translate(0.101 0.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11615",
    "data-name": "Path 11615",
    d: "M10.971,6.258,7.234,9.995,3.5,6.258",
    transform: "translate(0.07 0.228)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0.399 0.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 9.512,
    transform: "translate(6.856)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11616",
    "data-name": "Path 11616",
    d: "M.5,10.525v1.122a3.528,3.528,0,0,0,3.529,3.527h6.755a3.527,3.527,0,0,0,3.527-3.527V10.525",
    transform: "translate(-0.5 0.072)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.01473e17303cb8054c71d367d4acbc24.svg";
export { ForwardRef as ReactComponent };